import { useRequiredContext } from "@redotech/react-util/context";
import { TeamContext } from "@redotech/redo-web/context/team-context";
import { createContext, memo } from "react";

export interface InventoryManagementSuiteStatuses {
  imsEnabled: boolean;
}

export const InventoryManagementSuiteStatusesContext = createContext<
  InventoryManagementSuiteStatuses | undefined
>(undefined);

export const InventoryManagementSuiteStatusesProvider = memo(
  function InventoryManagementSuiteStatusesProvider({
    children,
  }: {
    children: React.ReactNode;
  }) {
    const team = useRequiredContext(TeamContext);

    const imsEnabled = team?.settings?.ims?.enabled ?? false;

    const inventoryManagementSuiteStatuses = { imsEnabled };

    return (
      <InventoryManagementSuiteStatusesContext.Provider
        value={inventoryManagementSuiteStatuses}
      >
        {children}
      </InventoryManagementSuiteStatusesContext.Provider>
    );
  },
);
